declare var POLYFILLS_PATH: string;
declare var window: any;
declare var __webpack_public_path__: any;
__webpack_public_path__ = '/front_assets/';

import { Application } from 'stimulus';
import { definitionsFromContext } from 'stimulus/webpack-helpers';

import loadScript from './helpers/loadScript';
import shouldLoadPolyfills from './helpers/shouldLoadPolyfills';
import './polyfills/requestIdleCallback.js';
import './polyfills/isNaN.js';

import general from './containers/general';
import vacancies from './containers/vacancies';

const csrfMetaTag: HTMLMetaElement = document.head.querySelector('meta[name="csrf-token"]');
const token = csrfMetaTag.content;

$.ajaxSetup({
  beforeSend: (xhr) => {
    xhr.setRequestHeader('X-CSRF-TOKEN', token);
  },
});

// Make sure these global variables exist
['App', 'POLYFILLS_PATH'].forEach((gl) => {
  if (typeof window[gl] === 'undefined') {
    throw new Error(`${gl} is not defined`);
  }
});

const ready = () => {
  const application = Application.start();
  const context = require.context('./controllers', true, /\.js$/);
  application.load(definitionsFromContext(context));


  general();

  if (document.getElementsByClassName('js-vacancies')) {
    vacancies();
  }
};

if (shouldLoadPolyfills()) {
  loadScript(POLYFILLS_PATH, ready);
} else {
  ready();
}

if ('serviceWorker' in navigator && window.isSecureContext !== false) {
  navigator.serviceWorker.register('/service-worker.js');
}
